module.exports = __webpack_public_path__ + "img/ren_5.0a712b93.webp";